import React from 'react';
import {ShowGuesser} from "@api-platform/admin";

const FlightSubscriptionShow = (props) => {
    return (
            <ShowGuesser {...props} />
    );
};

export default FlightSubscriptionShow;
